
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'Scenariusz',
	'noDashboardFound': 'Nie można pobrać scenariusza. Albo już nie istnieje, albo nie masz uprawnień potrzebnych, by go wyświetlić.',
	'noDashboardCapability': 'Nie masz możliwości używania scenariuszy',
	'noDashboardPermision': 'Nie masz odpowiednich uprawnień do wyświetlania tego scenariusza',
	'defaultName': 'Nowy scenariusz',
	'storyProperties': 'Właściwości scenariusza',
	'createAvDataStoryLabel': 'Scenariusz',
	'createAvSlideShowLabel': 'Pokaz slajdów',
	'createAvPanAndZoomLabel': 'Podróż edukacyjna',
	'dashboard_save_success': 'Scenariusz został zapisany.',
	'cmEmptySelection': 'Scenariusz został usunięty. Spróbuj zapisać go jako nowy scenariusz.',
	'createStoryTitle': 'Utwórz scenariusz',
	'transitionStyleTitle': 'Styl przejścia',
	'createButton': 'Utwórz',
	'cancelButton': 'Anuluj',
	'dashboardResetTitle': 'Przywróć scenariusz',
	'dashboardResetMessage': 'Czy na pewno chcesz cofnąć wszystkie zmiany wprowadzone w tym scenariuszu?',
	'dashboardResetToast': 'Scenariusz został zresetowany.',
	'filter_drag_and_drop_all_tabs': 'Przeciągnij i upuść dane w tym miejscu, aby przefiltrować wszystkie sceny.',
	'filter_drag_and_drop_current_tab': 'Przeciągnij i upuść dane w tym miejscu, aby przefiltrować tę scenę.',
	'filterIconLabel_Global': 'Wszystkie sceny',
	'filterIconLabel_Tab': 'Ta scena',
	'filterIconTooltip_Global': 'Wszystkie sceny',
	'filterIconTooltip_Tab': 'Ta scena',
	'filterOverflowMenu_Global': 'Menu rozszerzone wszystkich scen',
	'filterOverflowMenu_Tab': 'Menu rozszerzone tej sceny',
	'renameScene': 'Zmień nazwę sceny',
	'duplicateScene': 'Duplikuj scenę',
	'deleteScene': 'Usuń scenę',
	'editTimelineHighlight': 'Edytuj podświetlenie',
	'deleteTimelineHighlight': 'Usuń podświetlenie',
	'filter_includesAll': 'Uwzględnia wszystkie',
	'timeline_highlight_moved_to': 'Filtr diagramu chronologicznego %{id} przeniesiono do %{time}',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Zaznacz',
	'newDefaultStoryName': 'Scenariusz: %{modelName}',
	'exportLabel': 'Zapisz',
	'exportAsLabel': 'Zapisz jako:',
	'exportDialogTitle': 'Zapisz jako scenariusz',
	'exportDialogFooter': 'Przyciski zapisu i anulowania',
	'loadAfterExportLabel': 'Otwórz scenariusz po zapisaniu',
	'selectTemplateLabel': 'Wybierz szablon',
	'outOfBoundsWarningMessage': 'Niektóre widgety kokpitu znajdują się poza siatką i po eksporcie mogą nie być prawidłowo wyświetlane.',
	'emptyExploreCardsWarningMessage': 'Puste karty zostały usunięte podczas zapisywania jako scenariusza.',
	'dashboard_export_success': 'Kokpit został pomyślnie zapisany jako scenariusz.',
	'explore_export_success': 'Eksploracja została pomyślnie zapisana jako scenariusz.',
	'toastUpgradeDone': 'Scenariusz został zaktualizowany. Zapisz teraz, aby utrzymać optymalną wydajność.',
	'navigationMarker': 'Znacznik nawigacyjny',
	'navigateMarkers': 'Znaczniki nawigacyjne',
	'navNextMarker': 'Następny znacznik',
	'navPrevMarker': 'Poprzedni znacznik',
	'navPrevMarkerAbbreviated': 'Poprzedni znacznik',
	'timelineSettingsButton': 'Opcje odtwarzania',
	'autoPlay': 'Odtwórz wszystkie sceny',
	'loop': 'Pętla',
	'refreshData': 'Odśwież przy rozpoczęciu',
	'slideshowLabel': 'Pokaz slajdów',
	'panAndZoomLabel': 'Podróż edukacyjna',
	'slideShowLayoutLabel': 'Układ pokazu slajdów',
	'panAndZoomLayoutLabel': 'Układ podróży edukacyjnej',
	'panAndZoomLayoutFooter': 'Układ podróży edukacyjnej to zbiór scen w pojedynczej kanwie. Po uruchomieniu tego typu scenariusza w prezentacji nastąpi powiększanie i przesuwanie po kolei poszczególnych scen. Na tym polega różnica w odniesieniu do pokazu slajdów, w którym każda scena jest prezentowana w nowej kanwie. Układ podróży edukacyjnej z trzema scenami połączonymi liniami pozwala na utworzenie poziomej sekwencji scen. Jest to przydatne podczas przedstawiania osi czasu.',
	'PanAndZoomLayout1': '5 scen ułożonych na kształt prostokąta',
	'PanAndZoomLayout2': '4 sceny ułożone na kształt schodów skierowanych w górę, od lewej strony do prawej',
	'PanAndZoomLayout3': '6 scen ułożonych na kształt prostokąta',
	'PanAndZoomLayout4': '7 scen ułożonych na kształt prostokąta, przy czym 6 małych scen znajduje się u góry, a 1 duża scena u dołu',
	'PanAndZoomLayout5': '3 sceny ułożone tak, że 2 małe znajdują się na górze, a 1 duża na dole',
	'PanAndZoomLayout6': 'Sekwencja 4 scen ułożonych w poziomie',
	'pageSelectWarning': 'Wybierz scenę.',
	'noSceneTransitionLabel': 'Brak',
	'sceneTransitionPropertyLabel': 'Przejście sceny',
	'animatedPathSceneTransitionLabel': 'Ścieżka animowana',
	'sweepSceneTransitionLabel': 'Przebieg',
	'storyTypeLabel': 'Typ scenariusza',
	'layoutLabel': 'Układ',
	'tabName_animation': 'Animacja',
	'propAniAnimation': 'Animacja',
	'propAniTypeEntrance': 'Animacja wejściowa',
	'propAniDirectionIn': 'Kierunek wejścia',
	'propAniTypeExit': 'Animacja wyjściowa',
	'propAniDirectionOut': 'Kierunek wyjścia',
	'propAniDirection': 'Kierunek',
	'propAniEntrance': 'Wejście',
	'propAniTypeEntranceSlideIn': 'Wsuwanie',
	'propAniTypeEntranceFadeIn': 'Pojawianie się',
	'propAniTypeEntrancePivotIn': 'Wkręcanie',
	'propAniTypeEntranceScaleIn': 'Powiększanie',
	'propAniTypeEntranceShrinkIn': 'Zmniejszanie',
	'propAniDirectionInLeft': 'Od lewej',
	'propAniDirectionInRight': 'Od prawej',
	'propAniDirectionInTop': 'Od góry',
	'propAniDirectionInBottom': 'Od dołu',
	'propAniExit': 'Zakończ',
	'propAniTypeExitSlideIn': 'Wysuwanie',
	'propAniTypeExitFadeIn': 'Znikanie',
	'propAniTypeExitPivotOut': 'Wykręcanie',
	'propAniTypeExitScaleIn': 'Pomniejszanie',
	'propAniTypeExitExpandOut': 'Rozszerzanie',
	'propAniDirectionOutLeft': 'Do lewej',
	'propAniDirectionOutRight': 'Do prawej',
	'propAniDirectionOutTop': 'Na początek',
	'propAniDirectionOutBottom': 'Na koniec',
	'propAniEntranceTime': 'Początek (s):',
	'propAniExitTime': 'Koniec (s):',
	'animationNoEntranceText': 'Animacja wejściowa nie zostanie wykonana, jeśli widget znajduje się na początku sceny.',
	'animationNoExitText': 'Animacja wyjściowa nie zostanie wykonana, jeśli widget znajduje się na końcu sceny.',
	'propAniTypeDataEntrance': 'Wejście danych',
	'propAniRevealDuration': 'Czas trwania animacji wejściowej',
	'timelineAnimationProperties': 'Otwórz właściwości animacji',
	'scenesPropertiesSection': 'Sceny',
	'editStoryCoachMarkTitle': 'Edytuj scenariusz',
	'editStoryCoachMarkContents': 'Kliknij ikonę ołówka, aby edytować ten scenariusz.',
	'addDataStoryCoachMarkContents': 'Przeciągnij i upuść dane z panelu do scenariusza.',
	'expandSceneCoachmarkTitle': 'Otwórz oś czasu',
	'expandSceneCoachmarkContents': 'Animuj scenę, dostosowując widoczność obiektu na podstawie czasu i czasu trwania.',
	'overviewCoachmarkTitle': 'Sceny przeglądu',
	'overviewCoachmarkContents': 'Użyj scen przeglądu na początku i na końcu scenariusza, aby wyświetlić obraz wszystkich scen. W obszarze scen przeglądu kliknij i przeciągnij scenę, aby zamienić kolejność pomiędzy scenami. Sceny przeglądu można wyświetlać lub ukrywać we właściwościach scenariusza.',
	'animatedPathCoachmarkTitle': 'Ścieżka animowana',
	'animatedPathCoachmarkContents': 'Aby animować ruch obiektu z jednej sceny do drugiej, zduplikuj scenę z obiektem. Następnie w nowej scenie przesuń lub obróć zduplikowany obiekt bądź zmień jego wielkość.',
	'propShowStoryOverviewFirstSlide': 'Pokaż wszystkie sceny na początku',
	'propShowStoryOverviewLastSlide': 'Pokaż wszystkie sceny na końcu',
	'storySceneSingleCountLabel': '1 scena',
	'storySceneCountLabel': '%{count} scen(y)',
	'storySceneRangeCountLabel': 'Scena %{index} z %{count}',
	'storySceneExpand': 'Otwórz oś czasu',
	'storySceneActionMenu': 'Menu opcji uruchamiania sceny',
	'timelineRightContainerLabel': 'Grupa sterująca przycisków diagramu chronologicznego',
	'timelineViewLabel': 'Diagram chronologiczny',
	'timelineZoomFit': 'Dopasuj powiększenie',
	'timelineZoomIn': 'Powiększ',
	'timelineZoomOut': 'Pomniejsz',
	'timelinePositionIndicator': 'wskaźnik pozycji osi czasu na %{position}',
	'timelinePositionIndicatorMoveLeftTo': 'przesunięcie wskaźnika położenia na osi czasu w lewo do %{position}',
	'timelinePositionIndicatorMoveRightTo': 'przesunięcie wskaźnika położenia na osi czasu w prawo do %{position}',
	'sceneStart': 'Przeskocz na początek sceny do %{position}',
	'sceneEnd': 'Przeskocz na koniec sceny do %{position}',
	'timelineHighlightTitle': 'Podświetlenie',
	'addTimelineHighlight': 'Dodaj podświetlenie',
	'addSceneBtnTitle': 'Dodaj nową scenę z szablonem domyślnym',
	'addSceneChevronBtnTitle': 'Wybierz szablon sceny',
	'timelinePlay': 'Odtwórz',
	'timelinePause': 'Wstrzymaj',
	'sceneNavigation': 'Nawigacja w scenie',
	'navNextScene': 'Następna scena',
	'navPrevScene': 'Poprzednia scena',
	'navPrevSceneAbbreviated': 'Poprz. scena',
	'navExitFullScreen': 'Wyjdź z trybu pełnoekranowego',
	'navToggleOverview': 'Włącz/wyłącz przegląd',
	'rowNumber': 'Wiersz %{number}',
	'overviewBtnLabel': 'Przegląd',
	'sceneListStart': 'Początek przeglądu',
	'sceneListEnd': 'Koniec przeglądu',
	'timelineLeftHandle': 'lewy uchwyt dla %{name}',
	'timelineRightHandle': 'prawy uchwyt dla %{name}',
	'timelineLeftHandleNoTitle': 'uchwyt po lewej stronie',
	'timelineRightHandleNoTitle': 'uchwyt po prawej stronie',
	'timelineMoveLeft': 'Przesuń %{object} w lewo',
	'timelineMoveRight': 'Przesuń %{object} w prawo',
	'timelineMoveWidget': 'widget diagramu chronologicznego przeniesiono do %{newStartTime} i %{newEndTime}',
	'timelineMoveWidgetStartTime': 'czas rozpoczęcia widgetu diagramu chronologicznego zmieniono na %{newStartTime}',
	'timelineMoveWidgetEndTime': 'czas zakończenia widgetu diagramu chronologicznego zmieniono na %{newEndTime}',
	'timelineMoveWidgetDown': 'widget diagramu chronologicznego przeniesiono niżej',
	'timelineMoveWidgetUp': 'widget diagramu chronologicznego przeniesiono wyżej',
	'addSceneTitle': 'Dodaj scenę',
	'blankSceneLayout': 'Puste',
	'titleSceneLayout': 'Tytuł z podtytułem',
	'sceneLayout1': 'Tytuł z tekstem obok jednej wizualizacji',
	'sceneLayout2': 'Tytuł z jedną wizualizacją',
	'sceneLayout3': 'Tytuł z dwiema wizualizacjami',
	'sceneLayout4': 'Wielozadaniowa',
	'sceneLayout5': 'Bez tytułu z tekstem obok jednej wizualizacji',
	'sceneLayout6': 'Wielozadaniowa 2 na 2',
	'sceneLayout7': 'Wielozadaniowa 2 obok 1',
	'sceneLayout8': 'Wielozadaniowa 1 obok 2',
	'sceneLayout9': 'Wielozadaniowa 1 powyżej 2',
	'sceneLayout10': 'Wielozadaniowa 2 powyżej 1',
	'sceneLayout11': 'Wielozadaniowa 4 powyżej 1',
	'sceneLayout12': 'Wielozadaniowa 1 powyżej 1 obok 2 na 2 powyżej 1',
	'titleWidgetPlaceholderText': 'W tym miejscu wprowadź tytuł',
	'subtitleWidgetPlaceholderText': 'Tutaj wprowadź podtytuł',
	'createStoryViewTitle': 'Utwórz scenariusz',
	'defaultStoryName': 'Nowy scenariusz',
	'screenshot_label': 'Scenariusz %{title}',
	'screenshot_label_scene': 'Scena %{sceneTitle} scenariusza %{title}',
	'filmstripHandleOpenLabel': 'Otwórz selektor scen',
	'filmstripHandleCloseLabel': 'Otwórz selektor scen'
});
